require('slick-carousel');

if($('.events-list').length) {

    let eventsContainer = $('.events-list-container'),
        eventsPaginationContainer = $('.events-pagination-container'),
        eventsNextPage = $('.events-navigation-item.navigation-next'),
        eventsPrevPage = $('.events-navigation-item.navigation-prev'),
        gardenFilterItems = $('.event-filter-garden').find('a'),
        typeFilterItems = $('.event-filter-type').find('a'),
        gardenFilterAll = $('.event-filter-garden-all'),
        typeFilterAll = $('.event-filter-type-all'),
        startDateFilter = $('#event_date_start_filter'),
        endDateFilter = $('#event_date_end_filter'),
        clearFiltersButton = $('.filters-clear a'),
        currentPage = 1,
        gardenFilter = '',
        typeFilter = '';

    if(typeof window.selected_event_garden !== 'undefined') {
        gardenFilter = window.selected_event_garden;
        $('.event-filter-garden').find('a[data-garden="' + gardenFilter + '"]').addClass('active');
        gardenFilterAll.removeClass('d-none');
        performEventsSearch();
    }

    if(typeof window.selected_event_type !== 'undefined') {
        typeFilter = window.selected_event_type;
        $('.event-filter-type').find('a[data-type="' + typeFilter + '"]').addClass('active');
        typeFilterAll.removeClass('d-none');
        performEventsSearch();
    }

    eventsNextPage.on('click', function (e) {
        e.preventDefault();
        currentPage++;
        performEventsSearch();
    });

    eventsPrevPage.on('click', function (e) {
        e.preventDefault();
        currentPage--;
        performEventsSearch();
    });

    startDateFilter.on('change', function () {
        if(endDateFilter.val().length === 0) {
            endDateFilter.val(startDateFilter.val());
        }

        performEventsSearch();
    });

    endDateFilter.on('change', function () {
        performEventsSearch();
    });

    $(document).on('click', '.event-pagination-item', function (e) {
        e.preventDefault();
        currentPage = $(this).data('page');
        performEventsSearch();
    });

    gardenFilterItems.on('click', function (e) {
        e.preventDefault();
        gardenFilter = $(this).data('garden');

        gardenFilterItems.not($(this)).removeClass('active');
        $(this).addClass('active');

        if(gardenFilter.length) {
            gardenFilterAll.removeClass('d-none');
        } else {
            gardenFilterAll.addClass('d-none');
        }

        currentPage = 1;
        performEventsSearch();
    });

    typeFilterItems.on('click', function (e) {
        e.preventDefault();
        typeFilter = $(this).data('type');

        typeFilterItems.not($(this)).removeClass('active');
        $(this).addClass('active');

        if(typeFilter.length) {
            typeFilterAll.removeClass('d-none');
        } else {
            typeFilterAll.addClass('d-none');
        }

        currentPage = 1;
        performEventsSearch();
    });

    function clearFiltersCheck() {
        if(gardenFilter.length || typeFilter.length || startDateFilter.val().length || endDateFilter.val().length) {
            $('.filters-clear').removeClass('hiding');
        } else {
            $('.filters-clear').addClass('hiding');
        }
    }

    clearFiltersButton.on('click', function (e) {
        e.preventDefault();
        gardenFilter = '';
        typeFilter = '';
        startDateFilter.val('');
        endDateFilter.val('');

        gardenFilterItems.removeClass('active');
        typeFilterItems.removeClass('active');
        gardenFilterAll.addClass('d-none');
        typeFilterAll.addClass('d-none');

        currentPage = 1;
        performEventsSearch();
    });

    function performEventsSearch() {

        clearFiltersCheck();

        eventsContainer.addClass('loading');

        $.post("/wp-admin/admin-ajax.php", {
            'action': 'events_results',
            'page': currentPage,
            'garden': gardenFilter,
            'type': typeFilter,
            'start_date': startDateFilter.val(),
            'end_date': endDateFilter.val()
        }, function (response) {
            if(response.success) {
                eventsContainer.html(response.data.html);
                eventsPaginationContainer.html(response.data.pagination);
                if(response.data.prev_active) {
                    eventsPrevPage.removeClass('disabled');
                } else {
                    eventsPrevPage.addClass('disabled');
                }

                if(response.data.next_active) {
                    eventsNextPage.removeClass('disabled');
                } else {
                    eventsNextPage.addClass('disabled');
                }

                // scroll to top of eventsContainer
                $('html, body').animate({
                    scrollTop: eventsContainer.offset().top - 100
                });
            }

            eventsContainer.removeClass('loading');
        });

    }

}


if($(".event-slider-container").length) {

    let sliderContainer = $('.event-slider-container'),
        sliderPrev = $('.event-slider-prev'),
        sliderNext = $('.event-slider-next');

    let slider = sliderContainer.slick({

    });

    sliderPrev.on('click', function () {
        slider.slick('slickPrev');
    });

    sliderNext.on('click', function () {
        slider.slick('slickNext');
    });

}
